import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './PartnershipsPage.css';

const pillars=[
  ['01','Shared Expertise','Combining knowledge and experience to solve complex challenges.','FiUsers'],
  ['02','Innovation','Creating new solutions through collaboration and fresh perspectives.','FiZap'],
  ['03','Expanded Capability','Connecting resources,technology,and relationships to do more together.','FiLayers'],
  ['04','Shared Success','Building outcomes that create durable value for every stakeholder.','FiTrendingUp']
];

const partnershipModels=[
  ['Business Alliances','Long-term relationships with organizations that expand capability,reach,and opportunity.','FiBriefcase'],
  ['Financial Relationships','Collaborations that support accessibility,confidence,and sustainable business growth.','FiDollarSign'],
  ['Technology Partnerships','Working with technology leaders to build smarter systems and unlock innovation.','FiCpu'],
  ['Industry Collaboration','Connecting with experts and operators who bring valuable context to emerging opportunities.','FiGlobe'],
  ['Venture Development','Exploring new initiatives with partners who share our appetite for disciplined growth.','FiCompass'],
  ['Community Impact','Creating pathways that support entrepreneurs,businesses,and the communities around them.','FiHeart']
];

const principles=[
  'Trust before transaction',
  'Alignment over convenience',
  'Long-term thinking',
  'Clear communication',
  'Mutual accountability',
  'Disciplined execution'
];

function Pillar({item,index}) {
  return (
    <motion.article
      className="partnership-pillar"
      initial={{opacity:0,y:18}}
      whileInView={{opacity:1,y:0}}
      viewport={{once:true,amount:.2}}
      transition={{delay:index*.08}}
      whileHover={{y:-7}}
    >
      <div className="partnership-pillar-top">
        <span>{item[0]}</span>
        <SafeIcon name={item[3].replace('Fi','')} />
      </div>
      <h3>{item[1]}</h3>
      <p>{item[2]}</p>
    </motion.article>
  );
}

function PartnershipModel({model,index}) {
  return (
    <motion.article
      className="partnership-model"
      initial={{opacity:0,y:18}}
      whileInView={{opacity:1,y:0}}
      viewport={{once:true,amount:.15}}
      transition={{delay:index*.06}}
      whileHover={{y:-6}}
    >
      <div className="partnership-model-icon">
        <SafeIcon name={model[2].replace('Fi','')} />
      </div>
      <span className="partnership-model-number">0{index+1}</span>
      <h3>{model[0]}</h3>
      <p>{model[1]}</p>
      <SafeIcon icon={FiIcons.FiArrowUpRight} className="partnership-model-arrow" />
    </motion.article>
  );
}

function NetworkVisual() {
  return (
    <div className="partnership-network" aria-label="Illustration of connected strategic relationships">
      <div className="partnership-network-grid" />
      <div className="partnership-network-orbit orbit-main" />
      <div className="partnership-network-orbit orbit-vertical" />

      <svg
        className="partnership-network-connections"
        viewBox="0 0 600 525"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="partnership-connection" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#d4af37" stopOpacity=".88" />
            <stop offset="1" stopColor="#6eaeec" stopOpacity=".45" />
          </linearGradient>
        </defs>
        <line x1="300" y1="262" x2="113" y2="84" />
        <line x1="300" y1="262" x2="487" y2="142" />
        <line x1="300" y1="262" x2="490" y2="404" />
        <line x1="300" y1="262" x2="115" y2="450" />
        <circle cx="300" cy="262" r="4" />
      </svg>

      <motion.div
        className="partnership-network-core"
        animate={{
          boxShadow:[
            '0 0 0 0 rgba(212,175,55,.2),0 22px 65px rgba(0,0,0,.25)',
            '0 0 0 24px rgba(212,175,55,0),0 22px 65px rgba(0,0,0,.25)',
            '0 0 0 0 rgba(212,175,55,0),0 22px 65px rgba(0,0,0,.25)'
          ]
        }}
        transition={{duration:3.4,repeat:Infinity}}
      >
        <span>THE CONNECTING FORCE</span>
        <strong>ProfitYo</strong>
        <b>Global System</b>
        <i />
        <small>Shared vision · Greater impact</small>
      </motion.div>

      <div className="network-node network-node-one">
        <SafeIcon icon={FiIcons.FiUsers} />
        <span>Expertise</span>
      </div>
      <div className="network-node network-node-two">
        <SafeIcon icon={FiIcons.FiGlobe} />
        <span>Reach</span>
      </div>
      <div className="network-node network-node-three">
        <SafeIcon icon={FiIcons.FiCpu} />
        <span>Innovation</span>
      </div>
      <div className="network-node network-node-four">
        <SafeIcon icon={FiIcons.FiTrendingUp} />
        <span>Growth</span>
      </div>
    </div>
  );
}

function ImpactConnections() {
  return (
    <svg
      viewBox="0 0 440 440"
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{
        position:'absolute',
        inset:0,
        width:'100%',
        height:'100%',
        overflow:'visible',
        pointerEvents:'none',
        zIndex:1
      }}
    >
      <defs>
        <linearGradient id="impact-trust-line" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#d4af37" stopOpacity=".9" />
          <stop offset="1" stopColor="#6eaeec" stopOpacity=".5" />
        </linearGradient>
        <linearGradient id="impact-capability-line" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#d4af37" stopOpacity=".9" />
          <stop offset="1" stopColor="#6eaeec" stopOpacity=".5" />
        </linearGradient>
        <linearGradient id="impact-opportunity-line" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#d4af37" stopOpacity=".9" />
          <stop offset="1" stopColor="#6eaeec" stopOpacity=".5" />
        </linearGradient>
      </defs>
      <line x1="169" y1="169" x2="92" y2="64" stroke="url(#impact-trust-line)" strokeWidth="1.25" />
      <line x1="271" y1="169" x2="356" y2="78" stroke="url(#impact-capability-line)" strokeWidth="1.25" />
      <line x1="274" y1="271" x2="360" y2="366" stroke="url(#impact-opportunity-line)" strokeWidth="1.25" />
    </svg>
  );
}

function PartnershipPageIntro() {
  return (
    <div className="partnership-page-intro">
      <span className="partnership-eyebrow">Why partnerships matter</span>
      <h2>The power of<br /><em>strategic collaboration.</em></h2>
      <p>
        Meaningful growth is rarely achieved in isolation. Strategic partnerships allow us to combine expertise,resources,technology,and innovation to create stronger outcomes for entrepreneurs,businesses,and communities.
      </p>
      <p>
        Through collaboration,we extend our capabilities,strengthen our ecosystem,and create opportunities for long-term success.
      </p>
    </div>
  );
}

export default function PartnershipsPage() {
  return (
    <div className="partnerships-page">
      <section className="partnerships-hero">
        <div className="partnerships-hero-grid" />
        <div className="partnerships-hero-glow" />
        <div className="container partnerships-hero-layout">
          <motion.div
            className="partnerships-hero-copy"
            initial={{opacity:0,x:-24}}
            animate={{opacity:1,x:0}}
          >
            <span className="partnership-eyebrow">Strategic partnerships</span>
            <h1>
              Strategic alliances.
              <br />
              <em>Shared vision.</em>
              <br />
              Greater impact.
            </h1>
            <p>
              ProfitYo Global System believes sustainable growth is built through collaboration. By working alongside trusted organizations,industry leaders,and innovative partners,we create opportunities that strengthen our ecosystem and expand long-term value.
            </p>
            <p className="partnerships-hero-support">
              Strong partnerships multiply capabilities,accelerate innovation,and unlock possibilities that would be difficult to achieve alone.
            </p>
          </motion.div>

          <motion.div
            initial={{opacity:0,scale:.88}}
            animate={{opacity:1,scale:1}}
            transition={{duration:.7}}
          >
            <NetworkVisual />
          </motion.div>
        </div>
        <div className="partnerships-scroll">
          <span />
          Explore our approach
        </div>
      </section>

      <section className="partnerships-principles-section">
        <div className="container">
          <div className="partnerships-intro-layout">
            <PartnershipPageIntro />
            <div className="partnerships-intro-stat">
              <span>One relationship can change the direction of an entire system.</span>
              <strong>Collaboration<br />creates leverage.</strong>
              <i />
              <small>ProfitYo Global System</small>
            </div>
          </div>

          <div className="partnership-pillars">
            {pillars.map((pillar,index)=>(
              <Pillar key={pillar[0]} item={pillar} index={index} />
            ))}
          </div>
        </div>
      </section>

      <section className="partnership-models-section">
        <div className="container">
          <div className="partnerships-section-heading">
            <div>
              <span className="partnership-eyebrow">How we collaborate</span>
              <h2>Partnerships designed<br /><em>to create momentum.</em></h2>
            </div>
            <p>
              We build relationships across the areas where shared capability can create better opportunities,stronger businesses,and more resilient systems.
            </p>
          </div>

          <div className="partnership-model-grid">
            {partnershipModels.map((model,index)=>(
              <PartnershipModel key={model[0]} model={model} index={index} />
            ))}
          </div>
        </div>
      </section>

      <section className="partnerships-impact-section">
        <div className="container partnerships-impact-layout">
          <div className="partnerships-impact-visual">
            <div className="impact-circle impact-circle-large" />
            <div className="impact-circle impact-circle-small" />
            <ImpactConnections />
            <div className="impact-core">
              <span>SHARED</span>
              <strong>IMPACT</strong>
            </div>
            <span className="impact-label impact-label-one">TRUST</span>
            <span className="impact-label impact-label-two">CAPABILITY</span>
            <span className="impact-label impact-label-three">OPPORTUNITY</span>
          </div>

          <div>
            <span className="partnership-eyebrow">The value we seek to create</span>
            <h2>Better together.<br /><em>Stronger over time.</em></h2>
            <p>
              The most valuable partnerships do more than support a single initiative. They create a platform for continued learning,innovation,and opportunity across the entire relationship.
            </p>
            <div className="partnership-impact-list">
              <div><SafeIcon icon={FiIcons.FiCheckCircle} /><span>Stronger capabilities for every partner</span></div>
              <div><SafeIcon icon={FiIcons.FiCheckCircle} /><span>New opportunities for entrepreneurs and businesses</span></div>
              <div><SafeIcon icon={FiIcons.FiCheckCircle} /><span>Faster pathways from insight to execution</span></div>
              <div><SafeIcon icon={FiIcons.FiCheckCircle} /><span>Long-term value that compounds over time</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="partnership-philosophy-section">
        <div className="container partnership-philosophy-layout">
          <div>
            <span className="partnership-eyebrow">Our partnership philosophy</span>
            <h2>Built on trust.<br /><em>Measured by impact.</em></h2>
            <p>
              We look for partners who share our standards,our curiosity,and our commitment to building something that lasts. The right relationship is grounded in trust and strengthened through action.
            </p>
          </div>

          <div className="partnership-philosophy-list">
            {principles.map((principle,index)=>(
              <motion.div
                key={principle}
                className="partnership-philosophy-item"
                initial={{opacity:0,x:16}}
                whileInView={{opacity:1,x:0}}
                viewport={{once:true}}
                transition={{delay:index*.07}}
              >
                <span>0{index+1}</span>
                <strong>{principle}</strong>
                <SafeIcon icon={FiIcons.FiArrowUpRight} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="partnerships-closing">
        <div className="container">
          <span className="partnership-eyebrow">Build the future with us</span>
          <h2>The right partnership<br /><em>opens a larger opportunity.</em></h2>
          <p>
            We are always open to conversations with organizations,founders,operators,and institutions aligned with our long-term vision.
          </p>
          <a href="mailto:hello@profityoglobal.com" className="partnerships-button">
            Start a conversation
            <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </a>
        </div>
      </section>
    </div>
  );
}